// Provenance brands on what comes out of the crypto boundary; either direction takes any string in.
/* eslint-disable @typescript-eslint/no-unsafe-type-assertion -- minting the two brands is what this file is for */
export type PlainText = string & { __plaintext: never };
export type CypherText = string & { __cyphertext: never };

const base64 = {
  decode: (s: string) => Uint8Array.from(atob(s), c => c.charCodeAt(0)),
  encode: (b: Uint8Array) => btoa(String.fromCharCode(...b)),
};

export class Encryption {
  static readonly encoder = new TextEncoder();
  static readonly decoder = new TextDecoder();
  static readonly subtle = window.crypto.subtle;
  private readonly params: AesGcmParams = {
    name: 'AES-GCM',
    iv: Encryption.encoder.encode('whatever'),
  };

  constructor(private cryptoKey: CryptoKey) {}

  static create = async (key: string): Promise<Encryption> => {
    const cryptoKey = await Encryption.subtle.importKey('raw', base64.decode(key), 'AES-GCM', true, ['encrypt', 'decrypt']);
    return new Encryption(cryptoKey);
  };

  encrypt = async (data: string): Promise<CypherText> => {
    const payload = Encryption.encoder.encode(data);
    const cypherText: Uint8Array = new Uint8Array(await Encryption.subtle.encrypt(this.params, this.cryptoKey, payload));
    return base64.encode(cypherText) as CypherText;
  };

  decrypt = async (data: string): Promise<PlainText> => {
    const cypherText = base64.decode(data);
    const payload = await Encryption.subtle.decrypt(this.params, this.cryptoKey, cypherText);
    return Encryption.decoder.decode(payload) as PlainText;
  };
}
